import {Alert, Button, Divider, List, Tabs, createTheme} from '@mantine/core';

import classes from './theme.module.css';

export const theme = createTheme({
  primaryColor: 'yellow',

  autoContrast: true,

  components: {
    // Alert's body is flex:1 with min-width:auto and the root clips: a nested
    // list's bullet indent pushes its text past the padding and gets cut.
    Alert: Alert.extend({
      styles: {body: {minWidth: 0}, message: {minWidth: 0}},
    }),
    Button: Button.extend({
      defaultProps: {
        size: 'lg',
      },
      styles: {
        root: {flexShrink: 0},
        label: {textOverflow: 'ellipsis'},
      },
    }),
    Divider: Divider.extend({
      defaultProps: {
        mt: 'md',
        mb: 'md',
      },
    }),
    List: List.extend({
      defaultProps: {
        spacing: 'xs',
        mr: 10,
      },
      // Mantine's List.Item is `white-space: nowrap` around an inline-flex
      // wrapper, so an inside marker pushes the first line past the container.
      styles: {
        root: {
          listStylePosition: 'outside',
          paddingInlineStart: 'var(--mantine-spacing-md)',
        },
      },
    }),
    Tabs: Tabs.extend({
      classNames: {list: classes.tabsList},
    }),
  },
});
